import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { getHeader, getPartners } from '../services/api';

// Sayfalar
import App from '../App';
import Donanim from '../pages/Donanim';
import Yazilim from '../pages/Yazilim';
import AgCihazlari from '../pages/AgCihazlari';
import FizikselMedya from '../pages/FizikselMedya';
import Hizmetler from '../pages/Hizmetler';
import Belgeler from '../pages/Belgeler';
import Iletisim from '../pages/Iletisim';
import Personel from '../pages/Personel';
import Veri from '../pages/Veri';
import Iso27001 from '../pages/ISO27001';
import NedenBiz from '../pages/NedenBiz';
import Tesisler from "../pages/Tesisler";
import Fiyatlandirma from '../pages/Fiyatlandirma';
import ModulPage from '../pages/ModulPage';
import RuzyAI from '../pages/RuzyAI';

// Bileşenler
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import ScrollToTop from '../components/ScrollToTop';

const AppRouter = () => {
    const [headerData, setHeaderData] = useState(null);
    const [partnerler, setPartnerler] = useState([]);

    useEffect(() => {
        const fetchNavContent = async () => {
            try {
                const [hData, pData] = await Promise.all([
                    getHeader(),
                    getPartners()
                ]);

                if (hData) setHeaderData(hData);
                if (pData) setPartnerler(pData);
            } catch (error) {
                console.error("Navigasyon verileri yüklenirken hata oluştu:", error);
            }
        };

        fetchNavContent();
    }, []);

    return (
        <Router>
            <ScrollToTop />
            <Navbar
                data={headerData}
                partnerler={partnerler}
            />

            <Routes>
                <Route path="/" element={<App />} />
                <Route path="/donanim" element={<Donanim />} />
                <Route path="/yazilim" element={<Yazilim />} />
                <Route path="/ag-cihazlari" element={<AgCihazlari />} />
                <Route path="/fiziksel-medya" element={<FizikselMedya />} />
                <Route path="/veri" element={<Veri />} />
                <Route path="/personel" element={<Personel />} />
                <Route path="/belgeler" element={<Belgeler />} />
                <Route path="/tesisler" element={<Tesisler />} />
                <Route path="/hizmetler" element={<Hizmetler />} />
                <Route path="/iletisim" element={<Iletisim />} />
                <Route path="/iso-27001" element={<Iso27001 />} />
                <Route path="/fiyatlandirma" element={<Fiyatlandirma />} />
                <Route path="/neden-biz" element={<NedenBiz />} />
                <Route path="/moduller/:modulId" element={<ModulPage />} />
                <Route path="/ruzy-ai" element={<RuzyAI />} />
            </Routes>

            <Footer />
        </Router>
    );
};

export default AppRouter;